<template>
  <div class="change-passwd-page" v-loading="loading">
    <div class="title">修改密码</div>

    <div class="head">
      <div class="head-box">
        <div class="head-title">登录账户</div>
        <div class="head-content">{{ form.enterpriseNo }}</div>
      </div>
      <div class="head-box">
        <div class="head-title">手机号码</div>
        <div class="head-content">{{ form.phone }}</div>
      </div>
    </div>
    <div class="form-box">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">

        <el-form-item label="验证码" prop="smsCode">
          <div class="border-bg">
            <el-input placeholder="请输入验证码" maxlength="6" v-model="form.smsCode"></el-input>
            <el-button class="verify-code"
                       type="text"
                       @click="sendCode"
                       size="mini"
                       :disabled="disable">{{ buttonName }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <div class="border-bg">
            <el-input placeholder="请输入新密码" type="password" maxlength="20" v-model="form.password"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <div class="border-bg">
            <el-input placeholder="请输入新密码" type="password" maxlength="20"
                      v-model="form.confirmPassword"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="btn" type="primary" @click="onSubmit">确 认</el-button>
      </div>
    </div>
  </div>
</template>


<script>
import {getEnterprisesInfo, sendVerifyCode, updatePasswd} from "@/api/mycenter";

export default {
  beforeMount() {
    this.getEnterprisesInfo();
  },
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.form.password === this.form.confirmPassword) {
        callback();
      } else {
        return callback(new Error('两次密码输入不一致'));
      }
    };
    return {
      loading: false,
      form: {},
      buttonName: "获取验证码",
      count: 60,
      disable: false,
      rules: {
        smsCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {
            required: true,
            message: '密码长度8-16位，需要包含大写字母、小写字母、数字、特殊符 号中的两种或以上',
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          {required: true, message: '请再次输入新密码', trigger: 'blur'},
          {
            required: true,
            message: '密码长度8-16位，需要包含大写字母、小写字母、数字、特殊符 号中的两种或以上',
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
            trigger: 'blur'
          },
          {required: true, validator: validateConfirmPassword, trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let params = {
            smsCode: this.form.smsCode,
            password: this.form.password
          }
          this.loading = true
          updatePasswd(params).then(result => {
            this.loading = false
            if (result && result.code === "0") {
              this.form.smsCode = ''
              this.form.password = ''
              this.form.confirmPassword = ''
              this.$message.success("修改密码成功")
            } else {
              this.$message.error(result.msg)
            }
          })
        } else {
          return false;
        }
      });
    },
    sendCode() {
      this.disable = true;
      this.loading = true;
      sendVerifyCode().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.$message.success("发送验证码成功")
          let timeout = setInterval(() => {
            if (this.count < 1) {
              this.disable = false;
              this.buttonName = "重新获取";
              this.count = 60;
              clearInterval(timeout);
            } else {
              this.disable = true;
              this.buttonName = this.count-- + "s后重发";
            }
          }, 1000);
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.loading = false
        this.disable = false;
      });
    },
    getEnterprisesInfo() {
      this.loading = true;
      getEnterprisesInfo().then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          this.form = result.data;
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.change-passwd-page {
  padding: 30px 205px 30px;
  background: #FFFFFF;
  border-radius: 8px;

  .head {
    margin-top: 10px;

    .head-box {
      display: flex;
      margin-top: 20px;

      .head-title {
        width: 100px;
        font-size: 14px;
        font-weight: 400;
        color: #262728;
        margin-left: 10px;
      }

      .head-content {
        font-size: 14px;
        font-weight: 400;
        color: #262728;
      }
    }
  }

  .title {
    text-align: center;
    line-height: 1;
    font-size: 16px;
    font-weight: bold;
    color: #262728;
  }

  .subtitle {
    margin-top: 10px;
    line-height: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #F65B13;

    .iconfont {
      margin-right: 1px;
      font-size: 13px;
    }
  }

  .form-box {
    margin-top: 20px;

    .border-bg {
      display: flex;
      height: 42px;
      border: 1px solid #EDEFF2;
      border-radius: 10px;

      .verify-code {
        flex-shrink: 0;
        margin-right: 30px;
        font-size: 15px;
        font-weight: 400;
        color: #005EB1;
      }
    }

    .el-form-item {
      margin-bottom: 20px;

      .el-form-item__label {
        font-size: 14px;
        font-weight: 400;
        color: #262728;
      }

      .el-input__inner {
        height: 39px;
        border: none;
        border-radius: 10px;
      }

    }

    .el-upload--picture-card {
      border: none;
      width: 100px;
      height: 100px;
      border-radius: 10px;
    }

    .el-upload-list__item {
      width: 100px;
      height: 100px;
    }

    .camera {
      width: 100px;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #EDEFF2;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      font-size: 14px;
      font-weight: 400;
      color: #909399;
      line-height: 1;

      .iconfont {
        margin-bottom: 10px;
      }
    }

    .el-form-item__label {
      text-align: left;
    }
  }

  .btn-box {
    text-align: center;

    .btn {
      width: 103px;
      height: 42px;
      background: #FFCC00;
      border-radius: 8px;

      font-size: 16px;
      font-weight: bold;
      color: #262728;
    }
  }
}

</style>